module.exports = __webpack_public_path__ + "img/122.3.493e6084.png";